import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { usersApi } from '../api/users'
import { ApiError } from '../lib/api'
import { Spinner } from './Spinner'

export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [error, setError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: () => usersApi.changeOwnPassword(current, next),
    onError: (err) => setError(err instanceof ApiError ? err.message : 'Erro ao alterar senha'),
  })

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-3 text-lg font-bold text-slate-900">Alterar minha senha</h2>

        {mutation.isSuccess ? (
          <div className="space-y-3">
            <p className="rounded-md bg-green-50 px-3 py-2 text-sm text-green-700">
              Senha alterada com sucesso.
            </p>
            <button
              onClick={onClose}
              className="w-full rounded-md bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700"
            >
              Fechar
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
            <input
              type="password"
              placeholder="Senha atual"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className={inputCls}
            />
            <input
              type="password"
              placeholder="Nova senha (mín. 8 caracteres)"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className={inputCls}
            />
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setError(null)
                  if (next.length < 8) return setError('A nova senha deve ter ao menos 8 caracteres')
                  mutation.mutate()
                }}
                disabled={mutation.isPending || !current || !next}
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-md bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50"
              >
                {mutation.isPending && <Spinner className="h-4 w-4 text-white" />}
                Alterar
              </button>
              <button
                onClick={onClose}
                className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50"
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const inputCls =
  'w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none'
